import { Skeleton } from "@/components/ui/skeleton";

export default function LocationSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-4 min-[420px]:grid-cols-2 lg:grid-cols-4" role="status" aria-label="Loading job locations">
      {Array.from({ length: 8 }, (_, index) => (
        <div key={index} className="recent-job-card flex min-h-[94px] animate-pulse items-center p-4">
          <Skeleton className="h-9 w-9 shrink-0 rounded-md" />
          <span className="ml-3 min-w-0 flex-1 space-y-2">
            <Skeleton className="h-3.5 w-20" />
            <Skeleton className="h-3 w-16" />
          </span>
        </div>
      ))}
    </div>
  );
}
